

var mobileBreakpoint = 540;
var tabletBreakpoint = 768;

function isMobile() {
    return window.matchMedia("only screen and (max-width:" + mobileBreakpoint + "px)").matches;
}

function isTablet() {
    return window.matchMedia("only screen and (max-width:" + tabletBreakpoint + "px)").matches;
}

function showLoader(show){
    if(typeof show === 'undefined') show = true;
    loader.toggleClass('show', show);
}


function ajax(action, postData, succesCallback, errorCallback){

    postData = $.extend({}, postData, { action: action });

    $.ajax({
        type: "POST",
        url: ajax_url,
        data: postData,
        dataType: 'json',
        success: function(response){
            if(response === '0'){
                if(typeof errorCallback === 'function') errorCallback(response);
            }
            else {
                if(typeof succesCallback === 'function')  succesCallback(response);
            }
        },
        error: function(response){
            if(typeof errorCallback === 'function') {
                if(typeof response.responseJSON === 'object') {
                    errorCallback(response.responseJSON);
                }
                else if (typeof response.responseText === 'string' &&  response.responseText !== '') {
                    try {
                        var jsonErr = JSON.parse(response.responseText);
                        errorCallback(jsonErr);
                    } catch (e) {
                        errorCallback({'message': 'general'});
                    }

                }
                else {
                    errorCallback({'message': 'general'});
                }
            }
        }
    });

}

function alertModal(message, btnCallback){

    var html = '<div id="alertModal" class="modalDialog">\n' +
        '    <div class="fader"></div>\n' +
        '    <div class="inner">\n' +
        '        <div class="message">\n' +
        message +
        '        </div>\n' +
        '        <div class="buttons d-flex justify-content-center">\n' +
        '            <span class="btn btn-blue btn-ok">OK</span>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '</div>';


    var $modal = $(html);

    $modal.find('.btn-ok').click(function(){
        $modal.removeClass('show');
        setTimeout(function(){
            $modal.remove();
        },550);

    });

    $modal.appendTo('body');

    setTimeout(function(){
        $modal.addClass('show');
    },10);

}

$.fn.serializeForm = function() {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function() {
        if (o[this.name] !== undefined) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};



function strstr (haystack, needle, bool) {
  //var pos = 0;

  haystack += '';
  var pos = haystack.indexOf(needle);
  if (pos === -1) {
    return false;
  } else {
    if (bool) {
      return haystack.substr(0, pos);
    } else {
      return haystack.slice(pos);
    }
  }
}

function isset(variable){
    return (typeof variable!=='undefined');
}

function multistepForm($container, validationOptions, afterValidateCallback, submitHandler, navigationCallback){

    var validator;

    var $form = $container.find('form');
    var $steps = $container.find('#steps');
    var $stepsAndProgress = $container.find('#steps, #progress');

    var currentStep = 1;
    var numSteps = $steps.find('div.step:not(.error):last').data('step');

    var defaultValidationOptions = {
        errorElement: "span",
        errorClass: "form-error",
        errorPlacement: function ($error, $element) {

            var $container = $element.closest('.form-item-container');
            console.log($container);
            console.log($container.data('errorcontainer'));
            if($container.length && !! $container.data('errorcontainer')) {
                console.log($container);
                $error.appendTo('#'+$container.data('errorcontainer'));
            } else {
                if ($element.attr('type') === 'radio') {
                    $error.appendTo($element.closest('.form-radio-set'))
                } else if ($element.attr('type') === 'checkbox') {
                    $error.appendTo($element.closest('.form-checkbox'));
                } else {
                    $error.insertAfter($element);
                }
            }
        },
        submitHandler: submitHandler
    };

    validationOptions = $.extend(defaultValidationOptions, validationOptions);



    validator = $form.validate(validationOptions);

    var $nextBtns = $container.find(".nextStep");
    $nextBtns.click(function(){
        if($(this).hasClass('disabled')) return;

        if($form.valid()) {
            if(typeof afterValidateCallback === 'function'){
                var activeStepNum = $steps.find('div.step.active').data('step');
                afterValidateCallback(activeStepNum, function(valid, gotoErrorStep){
                    if(valid) nextStep();
                    else {
                        if(gotoErrorStep) errorStep(gotoErrorStep);
                    }
                });
            }
            else {
                nextStep();
            }
        }
    });

    var $prevBtns = $container.find(".prevStep");
    $prevBtns.click(function(){
        prevStep();
    });

    var $customPrevBtns = $container.find(".prevActiveStep");
    $customPrevBtns.click(function(){
        prevActiveStep();
    });


    function handleSubmit(form, ev){
        if(currentStep === numSteps) {
            if(typeof submitHandler === 'function') {
                submitHandler(form, ev);
            }
        }
        else {
            if($(form).valid()) {
                if(typeof afterValidateCallback === 'function'){
                    var activeStepNum = $steps.find('div.step.active').data('step');
                    if(! afterValidateCallback(activeStepNum)) return;
                }
                nextStep();
            }
        }
    }

    function nextStep(){

        var $currentStep = $stepsAndProgress.find('div.step.active');
        var $nextStep = $currentStep.next('div.step');

        var currentStepNum = parseInt($currentStep.data('step'));
        var destStepNum = parseInt($nextStep.data('step'));

        if(typeof navigationCallback === 'function') {
            navigationCallback(currentStepNum, destStepNum);
        }

        $currentStep.addClass('done').removeClass('active');
        $nextStep.addClass('active');
        validator.resetForm();

        currentStep = destStepNum;

        $("html, body").animate({ scrollTop: 0 }, 150);
    }

    function prevStep(){

        var $currentStep = $stepsAndProgress.find('div.step.active');
        var $prevStep = $currentStep.prev('div.step');

        var currentStepNum = parseInt($currentStep.data('step'));
        var destStepNum = parseInt($prevStep.data('step'));

        if(typeof navigationCallback === 'function') {
            navigationCallback(currentStepNum, destStepNum);
        }

        $currentStep.removeClass('active');
        $prevStep.removeClass('done').addClass('active');
        validator.resetForm();

        currentStep = destStepNum;

        $("html, body").animate({ scrollTop: 0 }, 150);
    }


    function prevActiveStep(){

        var $currentStep = $steps.find('div.step.active');
        var $prevActiveStep = $steps.find('div.previous-active-step');

        var currentStepNum = parseInt($currentStep.data('step'));
        var destStepNum = parseInt($prevActiveStep.data('step'));

        if(typeof navigationCallback === 'function') {
            navigationCallback(currentStepNum, destStepNum);
        }

        $currentStep.removeClass('active');
        $prevActiveStep.removeClass('done previous-active-step').addClass('active');

        currentStep = destStepNum;

        $("html, body").animate({ scrollTop: 0 }, 150);
    }

    function errorStep(step){

        var $currentStep = $steps.find('div.step.active');
        var $errorStep = $steps.find('div.step.error[data-step='+(step)+']');

        if($errorStep.length===0){
            $errorStep = $steps.find('div.step.error[data-step=general_error]');
        }

        $currentStep.removeClass('active').addClass('done previous-active-step');
        $errorStep.addClass('active');

        $("html, body").animate({ scrollTop: 0 }, 150);

    }

    var funcs = { prevStep: prevStep, nextStep: nextStep, errorStep: errorStep };
    return funcs;
}



jQuery.validator.addMethod("postcode", function(value, element, params) {
        	return this.optional(element) || /^\d{4} ?[a-z]{2}$/i.test(value);
        }, "Vul een geldige postcode in a.u.b.");

jQuery.validator.addMethod("telefoon", function(value, element, params) {
return this.optional(element) || /(^\+[0-9]{2}|^\+[0-9]{2}\(0\)|^\(\+[0-9]{2}\)\(0\)|^00[0-9]{2}|^0)([0-9]{9}$|[0-9\-\s]{10}$)/.test(value);
}, "Vul een geldig telefoonnummer in a.u.b.");

jQuery.validator.addMethod("adres", function(value, element, params) {
return this.optional(element) || /(^(?=.*\d)(?=.*[a-zA-Z]).{4,100}\s)/.test(value);
}, "Vul uw straat én huisnummer in");

jQuery.validator.addClassRules({
    telefoon:  { telefoon: true },
    adres: { adres: true },
    postcode: { postcode: true }
});

jQuery.validator.addMethod("email", function(value, element) {
    return this.optional( element ) || /^.+@\S+\.\S+$/.test( value );
}, "Vul een geldig e-mailadres in a.u.b.");


jQuery.extend( jQuery.validator.messages, {
    required: 'Het veld is niet (goed) ingevuld.',
    email: 'Vul een geldig e-mailadres in a.u.b.'
});

$.fn.toggleFormSelect = function(enabled){
    $(this).toggleClass('d-none', ! enabled);
    $(this).find('select').prop('disabled',!enabled);
};

function setCookie(name,value,days)
{
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    var secure = (document.location.protocol === 'https:')?';secure':'';
    document.cookie = name + "=" + value + expires + "; path=/"+secure;
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function clearCookie(name) {
    setCookie(name,"",-1);
}



(function($){
    $.fn.kiek = function(settings) {
        var $elems = this;
        var last = (this.length-1);

        var config = {
            'closeText' : 'sluiten',
            'titleText' : function(elem){
                return $(elem).find('img').attr('alt');
            },
            'easing'    : 'swing',
            'aspectratio': (16/9),
            'transitionSpeed': 300

        };


        if (settings){
            $.extend(config, settings);
        }

        var positionVideo = function(elem){



            screenHeight = $(window).height();
            screenWidth = $(window).width();
            maxHeight = Math.floor(screenHeight*0.8);
            if(screenWidth > 900){
                maxWidth = Math.floor(screenWidth-300);
            }
            else {
                maxWidth = Math.floor(screenWidth-0);
            }

            vidwidth = maxWidth;

            var aspectratio = config.aspectratio;
            if(typeof $(elem).data('kiek-aspectratio') != 'undefined') aspectratio = $(elem).data('kiek-aspectratio');


            vidheight = Math.floor((1/aspectratio)*vidwidth);

            if(vidheight > (screenHeight*0.8)){
                vidheight = maxHeight;
                vidwidth = Math.floor((aspectratio)*vidheight);
                marginTop = 0;
            }
            else {
                marginTop = Math.floor((maxHeight-vidheight)/2);
            }

            $("div#kiek iframe").attr('height',vidheight);
            $("div#kiek iframe").attr('width',vidwidth);
            $("div#kiek iframe").css({marginTop:marginTop});
        };

        var positionViewer = function(){
            screenHeight = $(window).height();
            screenWidth = $(window).width();
            $("div#kiek-left, div#kiek-right").css({lineHeight: screenHeight+ "px"});
        };

        var positionImage = function(){
            imgHeight = $('#kiek img').height();
    		imgWidth = $('#kiek img').width();
    		$('#kiek img').css({marginTop: "-" + imgHeight * 0.5 + "px", marginLeft: "-" + imgWidth * 0.5 + "px"});
    		$('#kiek img').fadeIn(config.transitionSpeed, config.easing);
        };
        var closeKiek = function(){
            //close kiek
            $("#kiek-container").fadeOut(config.transitionSpeed,config.easing,function(){
                $(this).remove();
                resetKiek();
            });
        };
        var resetKiek = function() {
            $(window).unbind('resize');//unbind resize
            $(document).unbind('keydown');//unbind keys
            $(".kiek-close").unbind('click');
            $("#kiek-left, #kiek-right").unbind('click');
        };
        var bindKiekEvents = function(elemnr){
            //bind window resize
            $(window).bind('resize',function(){
                elem = $elems[elemnr];
                positionViewer();
                positionImage();
                positionVideo(elem);
            });
            bindKiekKeys(elemnr);//bind keys
            //bind closers
    		$(".kiek-close").one('click',function(){
    		    closeKiek();
    		});
            //bind next/prev btns
            $("#kiek-right").one('click',function(){
                next = (elemnr==last) ? 0 : (elemnr+1);
                kiek(next);
            });
            $("#kiek-left").one('click',function(){
                prev = (elemnr==0) ? last : (elemnr-1);
                kiek(prev);
            });
        }
        var bindKiekKeys = function(elemnr) {
            //keys
            $(document).bind('keydown',function(e){
                if (e.keyCode==37){
                    //left
                    prev = (elemnr==0) ? last : (elemnr-1);
                    kiek(prev);
                    return false;
                }
                if(e.keyCode==39){
                    //right
                    next = (elemnr==last) ? 0 : (elemnr+1);
                    kiek(next);
                    return false;
                }
                if(e.keyCode==27){
                    //escape
                    closeKiek();
                    return false;
                }
            });
        }

        var kiek = function(elemnr){
            elem = $elems[elemnr];

            aantal = $elems.length;

            //unbind alles
            resetKiek();

            var titleText = config.titleText(elem);
            if(typeof titleText==='undefined') titleText='';
            //grote plaat is href van deze link
            var url = $(elem).attr('href');

            //viewer al aanwezig? (bij next/prev)
            var replace = ($("div#kiek-container").length!==0);
            if(!replace){
                //viewer maken
                var kiekviewer = "<div id='kiek-container'><div id='kiek-spinner'><i class='fa fa-spinner fa-spin' aria-hidden=\"true\"></i></div>'\
                                        <div id='kiek-overlay' class='kiek-close'></div>\
                                        <div id='kiek-left'>&lsaquo;</div><div id='kiek-right'>&rsaquo;</div>\
                                      </div>";
                $(kiekviewer).appendTo('body');
            }

            //next/prev?
            if(aantal==1){
                $('div#kiek-left,div#kiek-right').hide();
            }

            //content maken
            var kiekcontent = $("<div id='kiek-image'><div id='kiek-title' class='kiek-close'><span>" + titleText + "</span></div>\
                                <button id='kiek-close' class='kiek-close' aria-label='Sluiten' title='Sluiten'>" + config.closeText + "</button>\
                                <div id='kiek' title='Sluiten' class='kiek-close'>\
                                </div></div>");

            if($(elem).data('kiek-type')=='video'){
                //video
                video = true;
                var thisimage = "<iframe width='560' height='315' src='"+url+"' frameborder='0' allowfullscreen></iframe>";
            }
            else {
                //plaatje
                video = false;
                var thisimage = "<img class='kiek-close' src='" + url +"' title='" + config.closeText + "' alt='" +titleText+ "'>";
            }

            $(kiekcontent).find("#kiek").html(thisimage);

            if(replace) $("div#kiek-image").replaceWith(kiekcontent);
            else $(kiekcontent).appendTo("#kiek-container");

            positionViewer();
            bindKiekEvents(elemnr);

            //fade in + position image!
            if(video){
                positionVideo(elem);
            }
            else {
                $("#kiek > img").one('load',function(){
                    positionImage();
                });
            }

        }

        //do the magic:
        return this.each(function(i,item){
            $(this).bind('click',function(e){
                //link niet volgen
                e.preventDefault();
                kiek(i);
            });
        });

     };
})(jQuery);
